import React, { useCallback, useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import { API_ENDPOINTS } from '../config/api';

export default function QuotesListPage() {
  const { getAuthHeaders } = useCustomerAuth();
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [actingId, setActingId] = useState(null);

  const fetchQuotes = useCallback(() => {
    setLoading(true);
    fetch(API_ENDPOINTS.customerProfile.salesQuotes, { headers: getAuthHeaders() })
      .then((res) => {
        if (!res.ok) throw new Error('Could not load your quotes');
        return res.json();
      })
      .then((data) => setQuotes(data.quotes || []))
      .catch((err) => setError(err.message || 'Could not load your quotes'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchQuotes();
  }, [fetchQuotes]);

  const act = async (id, action) => {
    setActingId(id);
    try {
      const url = action === 'approve' ? API_ENDPOINTS.customerProfile.salesQuoteApprove(id) : API_ENDPOINTS.customerProfile.salesQuoteDecline(id);
      const res = await fetch(url, { method: 'POST', headers: getAuthHeaders() });
      if (!res.ok) throw new Error('Could not update this quote');
      await fetchQuotes();
    } catch (err) {
      setError(err.message || 'Could not update this quote');
    } finally {
      setActingId(null);
    }
  };

  return (
    <>
      <Header />
      <main className="section">
        <div className="container" style={{ maxWidth: 720 }}>
          <div className="masthead" style={{ marginBottom: '24px' }}>
            <span className="eyebrow">Account</span>
            <h1>Your quotes</h1>
          </div>

          {error && <div style={{ color: '#ef4444', marginBottom: '16px' }}>{error}</div>}
          {loading && <div className="loading" style={{ minHeight: '200px' }}><div className="loading-spinner" /></div>}

          {!loading && quotes.length === 0 && (
            <div style={{ textAlign: 'center', color: 'var(--text-light)', padding: '40px 0' }}>No quotes yet.</div>
          )}

          {quotes.map((quote) => (
            <div key={quote.id} className="list-row-card" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <div>
                  <div style={{ fontWeight: 700, color: 'var(--secondary-color)' }}>{quote.quoteNumber}</div>
                  <div style={{ fontSize: '13px', color: 'var(--text-light)', marginTop: '2px' }}>
                    ${quote.total?.toFixed?.(2) ?? quote.total} · expires {new Date(quote.expiresAt).toLocaleDateString()}
                  </div>
                </div>
                <span className="status-pill">{quote.status}</span>
              </div>

              {(quote.status === 'sent' || quote.status === 'viewed') && (
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button
                    type="button"
                    onClick={() => act(quote.id, 'approve')}
                    disabled={actingId === quote.id}
                    className="btn btn-primary"
                    style={{ flex: 1 }}
                  >
                    Approve
                  </button>
                  <button
                    type="button"
                    onClick={() => act(quote.id, 'decline')}
                    disabled={actingId === quote.id}
                    className="btn btn-secondary"
                    style={{ flex: 1 }}
                  >
                    Decline
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}
